import { Col, Form, Select } from "antd";
import { IMPORT_B2B_LC_LIST } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import { useCallback, useEffect, useState } from "react";

const B2BLcShippingGuaranteeCostFilterFields = () => {
  const { Option } = Select;
  const [b2bLcs, setB2bLcs] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchB2BLcs = async (filters = {}) => {
    setLoading(true);
    const params = {
      page: 1,
      per_page: 50,
      ...(filters.b2b_lc_number && { b2b_lc_number: filters.b2b_lc_number }),
    };

    const response = await getData(IMPORT_B2B_LC_LIST, null, params);
    if (response?.status === 200) {
      setB2bLcs(response?.data?.data?.data || []);
    }
    setLoading(false);
  };

  const handleSearch = useCallback(async (value) => {
    if (value && value.length >= 2) {
      await fetchB2BLcs({ b2b_lc_number: value });
    } else if (!value) {
      await fetchB2BLcs();
    }
  }, []);

  useEffect(() => {
    fetchB2BLcs();
  }, []);

  return (
    <>
      <Col span={6}>
        <Form.Item label="B2B LC Number" name="b2b_lc_number">
          <Select
            size="small"
            placeholder="Select B2B LC Number"
            loading={loading}
            allowClear
            showSearch
            optionFilterProp="children"
            onSearch={handleSearch}
          >
            {b2bLcs.map((lc) => (
              <Option key={lc.id || lc.b2b_lc_id} value={lc.id || lc.b2b_lc_id}>
                {lc.b2b_lc_number}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default B2BLcShippingGuaranteeCostFilterFields;

